/*
 * Module for defining chart themes
 */
rs.module("controls/data/chart-themes", [], function () {

    return {

        rsDefault: {
            baseTheme: 'ag-default',
            overrides: {
                pie: {
                    background: {
                        visible: false
                    },
                    legend: {
                        position: 'right'
                    }
                },
                bar: {
                    background: {
                        visible: false
                    },
                    legend: {
                        position: 'right'
                    }
                },
                line: {
                    background: {
                        visible: false
                    },
                    legend: {
                        position: 'right'
                    }
                }
            }
        },

        rsDark: {
            baseTheme: 'ag-default-dark',
            overrides: {
                pie: {
                    background: {
                        visible: false
                    },
                    legend: {
                        position: 'right'
                    }
                },
                bar: {
                    background: {
                        visible: false
                    },
                    legend: {
                        position: 'right'
                    }
                },
                line: {
                    background: {
                        visible: false
                    },
                    legend: {
                        position: 'right'
                    }
                }
            }
        }

    };
});